import { v4 as uuid } from 'uuid';
import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permissions from 'api/Apollo/permissions';
import { GET_SCHEMA_LIBRARIES } from 'api/schema-libraries/schema-libraries-query-builder';

import {
  mutation as insertSchemaLibraryMutation,
  buildVariables as buildInsertSchemaLibraryVariables,
} from './insert-schema-library-mutation-builder';

export default function useInsertSchemaLibrary(options = {}) {
  const [trackWithUser] = useTrackWithUser('schema_library_created');
  const [executeMutation, response] = useMutation(insertSchemaLibraryMutation, {
    ...options,
    refetchQueries: [GET_SCHEMA_LIBRARIES],
    context: { permission: permissions.createSchemas },
  });

  const insertSchemaLibrary = async ({ name, description }) => {
    const id = uuid();
    const response = await executeMutation({
      variables: buildInsertSchemaLibraryVariables({ id, name, description }),
    });

    if (!response.error) {
      trackWithUser();
    }
  };

  return [insertSchemaLibrary, response];
}
